<button
  class="
    {{ classOverrides }}
    ag1-button--small
    ag1-button--{{ variant }}
    flex
    items-center
    justify-center
    gap-3
  "
  [ngClass]="[
    position !== 'right' ? 'flex-row' : 'flex-row-reverse',
    isActive ? 'ag1-button--active' : '',
  ]"
  [ag1Tooltip]="tooltip"
  [tooltipPosition]="tooltipPosition"
  [tooltipTemplateRef]="tooltipTemplateRef"
  [tooltipHasArrow]="tooltipHasArrow"
  [tooltipVariant]="variant"
  [disabled]="disabled"
  (click)="onClick($event)"
>
  <ng-content />
  @if (label) {
    <span>
      @if (!formatWithSentenceCase) {
        {{ label }}
      }
      @if (formatWithSentenceCase) {
        {{ label | sentenceCase }}
      }
    </span>
  }
</button>
